/*
 * @Author: lmh
 * @Date: 2023-04-23 16:06:14
 * @LastEditors: lmh
 * @LastEditTime: 2023-04-23 17:01:41
 * @Description:
 */
import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/home'
import VideoCourse from '@/views/videoCourse'
import Message from '@/views/message'
import Creation from '@/views/creation'
import Login from '@/views/login'

Vue.use(Router)

function isMobile(){
  let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
  if (flag){
    return [
      {
        path: '/',
        name: 'index',
        component: () => import("@/views/mobile/index.vue"),
        meta: {
          title: '次元口袋编程',
          content: {
            keywords: '次元口袋,口袋网校,口袋英语同步学',
            description: '探索次元口袋，点燃孩子的创造力！我们致力于打造引人入胜的少儿编程体验，引领孩子们踏上思维之旅，培养独特的逻辑思维能力。让他们在编程的魔法世界中，展现无限潜能！',
            viewport:'width=device-width, initial-scale=1.0'
          }
        }
      }
    ]
  }else{
    return [
      {
        path: '/',
        name: 'Home',
        component: Home,
        meta: {
          title: '口袋网校',
          content: {
            keywords: '次元口袋,口袋网校,口袋英语同步学',
            description: '探索次元口袋，点燃孩子的创造力！我们致力于打造引人入胜的少儿编程体验，引领孩子们踏上思维之旅，培养独特的逻辑思维能力。让他们在编程的魔法世界中，展现无限潜能！',
            viewport:'width=device-width, initial-scale=1.0'
          }
        }
      },
      {
        path:"/videoCourse",
        name:'VideoCourse',
        component:VideoCourse,
        meta: {
          title: '编程视频课',
          content: {
            keywords: '次元口袋,口袋网校,口袋英语同步学',
            description: '开启创造力之门，次元口袋引领少儿编程！培养思维，磨炼逻辑，点燃孩子们的无限潜能！为孩子的未来奠定坚实基础，让家长放心，让孩子乐在其中！',
            viewport:'width=device-width, initial-scale=1.0'
          }
        }
      },
      {
        path:"/videoCourseDetail",
        name:'videoCourseDetail',
        component:() => import('@/views/videoCourse/courseDetail.vue'),
        meta: {
          title: '编程视频课',
          content: {
            keywords: '次元口袋,口袋网校,口袋英语同步学',
            description: '开启创造力之门，次元口袋引领少儿编程！培养思维，磨炼逻辑，点燃孩子们的无限潜能！为孩子的未来奠定坚实基础，让家长放心，让孩子乐在其中！',
            viewport:'width=device-width, initial-scale=1.0'
          }
        }
      },
      {
        path:"/creation",
        name:'Creation',
        component:Creation,
        meta: {
          title: '创作中心',
          content: {
            keywords: '次元口袋,口袋网校,口袋英语同步学',
            description: '开启创造力之门，次元口袋引领少儿编程！培养思维，磨炼逻辑，点燃孩子们的无限潜能！为孩子的未来奠定坚实基础，让家长放心，让孩子乐在其中！',
            viewport:'width=device-width, initial-scale=1.0'
          }
        }
      },
      {
        path:"/message",
        name:'Message',
        component:Message,
        meta: {
          title: '动态资讯',
          content: {
            keywords: '次元口袋,口袋网校,口袋英语同步学',
            description: '开启创造力之门，次元口袋引领少儿编程！培养思维，磨炼逻辑，点燃孩子们的无限潜能！为孩子的未来奠定坚实基础，让家长放心，让孩子乐在其中！',
            viewport:'width=device-width, initial-scale=1.0'
          }
        }
      },
      {
        path:"/messageDetail",
        name:'MessageDetail',
        component:() => import('@/views/message/components/MessageDetail'),
        meta: {
          title: '动态资讯',
          content: {
            keywords: '次元口袋,口袋网校,口袋英语同步学',
            description: '开启创造力之门，次元口袋引领少儿编程！培养思维，磨炼逻辑，点燃孩子们的无限潜能！为孩子的未来奠定坚实基础，让家长放心，让孩子乐在其中！',
            viewport:'width=device-width, initial-scale=1.0'
          }
        }
      },
      {
        path:"/login",
        name:'Login',
        component:Login,
        meta: {
          title: '登录、注册',
          content: {
            keywords: '次元口袋,口袋网校,口袋英语同步学',
            description: '开启创造力之门，次元口袋引领少儿编程！培养思维，磨炼逻辑，点燃孩子们的无限潜能！为孩子的未来奠定坚实基础，让家长放心，让孩子乐在其中！',
            viewport:'width=device-width, initial-scale=1.0'
          }
        }
      },
      {
        path:"/creation/workInfo",
        name:'WorkInfo',
        component:() => import('@/views/creation/workInfo'),
        meta: {
          title: '作品详情',
          content: {
            keywords: '次元口袋,口袋网校,口袋英语同步学',
            description: '开启创造力之门，次元口袋引领少儿编程！培养思维，磨炼逻辑，点燃孩子们的无限潜能！为孩子的未来奠定坚实基础，让家长放心，让孩子乐在其中！',
            viewport:'width=device-width, initial-scale=1.0'
          }
      }
    },
    {
      path:"/creation/EditC++",
      name:'EditC++',
      component:() => import('@/views/creation/views/EditC++.vue'),
      meta: {
        title: 'c++编辑',
        content: {
          keywords: '次元口袋,口袋网校,口袋英语同步学',
          description: '开启创造力之门，次元口袋引领少儿编程！培养思维，磨炼逻辑，点燃孩子们的无限潜能！为孩子的未来奠定坚实基础，让家长放心，让孩子乐在其中！',
          viewport:'width=device-width, initial-scale=1.0'
        }
    }
  }
    ]
  }
}

const routesList = isMobile()
console.log('router:',routesList)
export default new Router({
  mode:'hash',
  routes: routesList
})

// 获取原型对象push函数
const originalPush = Router.prototype.push
// 获取原型对象replace函数
const originalReplace = Router.prototype.replace
// 修改原型对象中的push函数
Router.prototype.push = function push(location){
return originalPush.call(this , location).catch(err=>err)
}
// 修改原型对象中的replace函数
Router.prototype.replace = function replace(location){
return originalReplace.call(this , location).catch(err=>err)
}



// WEBPACK FOOTER //
// ./src/router/index.js